module.exports = __webpack_public_path__ + "img/3.38721a6.jpg";